var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPagingLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg861",
    viewBox: "0 0 43.558064 70.587006",
    height: "70.587006mm",
    width: "43.558064mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs855"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.12869251,0.1325062)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_navigation_expand_less_24px",
    transform: "matrix(0,5.8822503,-5.8822503,0,-48.95137,-35.426008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "m 12,-8.3 -6,-6 1.41,-1.4 4.59,4.575 4.59,-4.58 1.41,1.405 z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagingLeft);
export default __webpack_public_path__ + "static/media/PagingLeft.1c89c0de9c42813d63a35cf2fe69720e.svg";
export { ForwardRef as ReactComponent };